//third party lib
import axios from "axios";
//utils
import {errorMessage} from "./../utils/toastMessage";


axios.defaults.headers.post["Content-Type"] = "application/json";

axios.interceptors.response.use(null, (error) => {
    const expectedErrors =
        error.response &&
        error.response.status >= 400 &&
        error.response.status < 500;
    if (!expectedErrors) {
        errorMessage("مشکلی از سمت سرور رخ داده است")
    }
    return Promise.reject(error)
});



export default {
    get: axios.get,
    post: axios.post,
    put: axios.put,
    delete: axios.delete,
};
